import React from 'react';

export const Icon = ({ className, children }) => (
    <span className={`icon ${className}`} style={{ fontFamily: 'Material Icons Outlined' }}>
        {children}
    </span>
);
